import { z } from 'zod';

import { Iso8601, Sha256Hex } from './primitives.js';

/**
 * Build pipeline output. The runtime checks `assetBundleHash` against the
 * on-disk asset bundle on boot; mismatch surfaces a config-error screen
 * (we do not render UI from possibly-tampered assets).
 */
export const Meta = z.object({
  builderVersion: z.string().min(1).max(40),
  builtAt: Iso8601,
  assetBundleHash: Sha256Hex,
});
export type Meta = z.infer<typeof Meta>;
